






































































import { Table, TableColumn, Tooltip } from 'element-ui';
import Badges from './badges.vue';
import SweetAlert from '@/util/classes/SweetAlert';
import { rules } from './../rules';
import { cashbackRules } from '@/components/Cashback/rules';
import { DiscountParams } from '@/store/interfaces/discount';
import {
  rulesDiscountAndCasbacks,
  tRulesDiscountAndCashbacks
} from '@/store/interfaces/discountAndCashbackRules';
import rulesDiscountAndCashbacks from '@/store/types/rulesDiscountAndCashbacks';
import { isCashbackRoute } from '@/components/Cashback/routeValidation';
import Vue, { PropType } from 'vue';
import { mapGetters, mapMutations } from 'vuex';

export default Vue.extend({
  name: 'TargetTable',
  components: {
    'el-tooltip': Tooltip,
    'el-table': Table,
    'el-table-column': TableColumn,
    Badges,
  },
  props: {
    targets: {
      type: Array as PropType<Array<rulesDiscountAndCasbacks>>,
      required: true,
    },
    model: {
      type: Object as PropType<DiscountParams>,
      required: true,
    },
  },
  methods: {
    ...mapMutations({
      removeRule: `discountAndCashbackRules/${rulesDiscountAndCashbacks.mutations.SET_REMOVE_RULES_VALIDATES}`,
    }),
    findDescriptionRule(id: string): string {
      if (this.syncedModel.rules[0].rule === 'all') {
        return 'Todos';
      }

      if (isCashbackRoute(this.$route)) {
        const rule = cashbackRules.find((rl) => rl.id === id);
        return rule ? rule.description : 'Desconocido';
      }
      const rule = rules.find((rl) => rl.id === id);
      return rule ? rule.description : 'Desconocido';
    },
    lineThrough(rule: rulesDiscountAndCasbacks): boolean {
      const rulesAllowed = ['commerces', 'branches', 'commerce_kinds'];
      return (
        this.syncedModel.kind === 'collective' &&
        !rulesAllowed.includes(rule.rule)
      );
    },
    onEdit(target: rulesDiscountAndCasbacks, position: number): void {
      const editFor = {
        index: position,
        ...target,
      };
      this.$emit('update', editFor);
    },
    onDelete(position: number, rule: tRulesDiscountAndCashbacks): void {
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: '¿Eliminar regla de segmentación?',
          text: 'Esta acción no podrá ser revertida.',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sí, eliminar',
          alertType: 'warning',
        })
        .then((res: boolean) => {
          if (res) {
            this.removeRule(rule);

            this.targetsSynced = this.targetsSynced.filter(
              (_, index: number) => index !== position
            );

            if (this.targetsSynced.length === 1) {
              this.targetsSynced = [{ rule: 'all', data: {}, meta: [], }];
            }
          }
        });
    },
  },
  computed: {
    ...mapGetters({
      rulesValidated: `discountAndCashbackRules/${rulesDiscountAndCashbacks.getters.GET_RULES_VALIDATED}`,
    }),
    targetsSynced: {
      get(): Array<rulesDiscountAndCasbacks> {
        return this.targets;
      },
      set(value: Array<rulesDiscountAndCasbacks>): void {
        this.$emit('update:targets', value);
      },
    },
    syncedModel: {
      get(): DiscountParams {
        return this.model;
      },
      set(value: DiscountParams): void {
        this.$emit('update:model', value);
      },
    },
  },
});
